import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dd02acf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-grid" }
const _hoisted_2 = { class: "news-column" }
const _hoisted_3 = { class: "older-post" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "older-label" }, "New Posts", -1))
const _hoisted_5 = { class: "news-grid" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "news-info" }
const _hoisted_9 = { class: "truncate-text" }
const _hoisted_10 = { class: "date-box" }
const _hoisted_11 = { class: "date" }
const _hoisted_12 = { class: "views" }
const _hoisted_13 = { class: "description truncate-text" }
const _hoisted_14 = { class: "older-post mt-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "older-label" }, "Older Post", -1))
const _hoisted_16 = { class: "news-grid" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "news-info" }
const _hoisted_20 = { class: "truncate-text" }
const _hoisted_21 = { class: "date-box" }
const _hoisted_22 = { class: "date" }
const _hoisted_23 = { class: "views" }
const _hoisted_24 = { class: "description truncate-text" }
const _hoisted_25 = { class: "frontSidebar" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "sponcer-title" }, [
  /*#__PURE__*/_createTextVNode(" Our "),
  /*#__PURE__*/_createElementVNode("b", { style: {"color":"#b4003a"} }, "Sponsors")
], -1))
const _hoisted_27 = { class: "sponsor-img-wrapper" }
const _hoisted_28 = ["src", "alt", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftSideBar = _resolveComponent("LeftSideBar")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_front_sidebar = _resolveComponent("front-sidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_LeftSideBar),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", null, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewAllPost && _ctx.viewAllPost(...args))),
              class: "cta-button"
            }, "View all Post")
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsItems, (news) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "news-card",
              onClick: ($event: any) => (_ctx.viewPostById(news)),
              key: news.id
            }, [
              _createElementVNode("img", {
                src: _ctx.extractImgUrl(news),
                alt: "news-image",
                class: "news-image"
              }, null, 8, _hoisted_7),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h2", _hoisted_9, _toDisplayString(news?.indlaeg_slug), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_va_icon, {
                    size: "15px",
                    name: "schedule"
                  }),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.formatDate(news?.updatedAt)), 1),
                  _createVNode(_component_va_icon, {
                    size: "15px",
                    name: "visibility"
                  }),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(news?.indlaeg_visninger || 0) + " views", 1)
                ]),
                _createElementVNode("p", _hoisted_13, _toDisplayString(news?.description), 1)
              ])
            ], 8, _hoisted_6))
          }), 128))
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", null, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewAllPost && _ctx.viewAllPost(...args))),
                class: "cta-button"
              }, "View all Post")
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsItems, (news) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "news-card",
                onClick: ($event: any) => (_ctx.viewPostById(news)),
                key: 'second-' + news.id
              }, [
                _createElementVNode("img", {
                  src: _ctx.extractImgUrl(news),
                  alt: "news-image",
                  class: "news-image"
                }, null, 8, _hoisted_18),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h2", _hoisted_20, _toDisplayString(news?.indlaeg_slug), 1),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_va_icon, {
                      size: "15px",
                      name: "schedule"
                    }),
                    _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.formatDate(news?.updatedAt)), 1),
                    _createVNode(_component_va_icon, {
                      size: "15px",
                      name: "visibility"
                    }),
                    _createElementVNode("p", _hoisted_23, _toDisplayString(news?.indlaeg_visninger || 0) + " views", 1)
                  ]),
                  _createElementVNode("p", _hoisted_24, _toDisplayString(news?.description), 1)
                ])
              ], 8, _hoisted_17))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_front_sidebar)
      ])
    ]),
    _hoisted_26,
    _createElementVNode("div", _hoisted_27, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sponsorsList, (sponsor) => {
        return (_openBlock(), _createElementBlock("img", {
          src: _ctx.mediaBaseUrl+sponsor?.sponsor_billede?.url,
          key: sponsor?.id,
          alt: sponsor?.sponsor_sponsornavn,
          class: "sponcer-image",
          onClick: ($event: any) => (_ctx.redirectTo(sponsor?.sponsor_link || 'https://google.com'))
        }, null, 8, _hoisted_28))
      }), 128))
    ])
  ], 64))
}